"use client";

import type { BlogData } from "@/services/public.service";
import Image from "next/image";
import Link from "next/link";

function Icon({ name, className = "" }: { name: string; className?: string }) {
  return <span className={`material-symbols-outlined ${className}`}>{name}</span>;
}

export default function BlogCard({ blog, locale, isAr }: { blog: BlogData; locale: string; isAr: boolean }) {
  const t = (a: string, e: string) => (isAr ? a : e);
  const title = isAr ? blog.title.ar : blog.title.en;
  const excerpt = isAr ? blog.excerpt.ar : blog.excerpt.en;
  const category = isAr ? blog.category?.ar : blog.category?.en;
  const img = blog.coverImage || "/defaults/destination.jpg";

  return (
    <Link
      href={`/${locale}/blog/${blog.slug || blog.id || blog._id}`}
      className="group flex flex-col rounded-2xl overflow-hidden border border-clay-100 bg-surface hover:shadow-md transition-all"
    >
      <div className="relative aspect-[16/9] bg-clay-100 overflow-hidden">
        <Image src={img} alt={title} fill unoptimized className="object-cover group-hover:scale-105 transition-transform duration-500" />
        {category && (
          <span className="absolute top-3 inset-s-3 rounded-full bg-clay-600 text-white text-xs font-bold px-3 py-1">{category}</span>
        )}
      </div>
      <div className="p-5 flex flex-col flex-1">
        <h3 className="font-bold text-lg text-ink-900 line-clamp-2 group-hover:text-clay-600 transition-colors">{title}</h3>
        <p className="text-sm text-ink-500 line-clamp-2 mt-2 flex-1">{excerpt}</p>
        <div className="mt-4 flex items-center gap-3 text-xs text-ink-500">
          <span className="inline-flex items-center gap-1"><Icon name="person" className="text-[15px]" />{blog.author}</span>
          <span className="inline-flex items-center gap-1"><Icon name="schedule" className="text-[15px]" />{blog.readMinutes} {t("د قراءة", "min read")}</span>
        </div>
      </div>
    </Link>
  );
}
